//const SERVER_IP = "192.168.1.112";
// const SERVER_IP = "localhost";
// const SERVER_IP = "149.56.26.231";
const SERVER_IP = "149.56.30.111";

// const SERVER_IP = "141.95.84.50";
// const SERVER_IP = "144.217.66.144";

const SERVER_PORT = "8182";
// const SERVER_PORT = "8082";

const GATEWAY = "/gateway";
const FINANCE = "/finance/";
const RETAIL = "/retail/";
const SALES = "/sales/";
const MARKETING = "/marketing";
const PRODUCTION = "/production";
const POS = "/pos/";

const RH = "/rh";
const BASE_CONFIG_EMAIL_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "email";
const BASE_LIVRAISON_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "livraison";
const BASE_HOME_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "home";
const BASE_JOURNALCAISSE_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "journal_caisse";
const BASE_PAYEMENT_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "payement";
const BASE_BANK_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "bank";
const BASE_WAREHOUSE_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "warehouse";
const BASE_SHOP_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "shop";
const BASE_CAISSE_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "cashRegister";
const BASE_USER_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "user";
const BASE_CLIENT_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "client";
const BASE_ORDER_POS_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + POS + "order";

  const BASE_KPI_PRODUCTION_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + PRODUCTION + "/kpi_production";

const BASE_PAYEMENT_SALES_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "payement";
const BASE_TIERS_ACCOUNT_SALE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "tiersAccount";

const BASE_CARTECADEAU_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  MARKETING +
  "/carteCadeau";

  const BASE_PROMOCAISSE_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  POS +
  "promoCaisse";

const BASE_TIERS_ACCOUNT_RETAIL_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "tiersAccount";
const CHARGE_ETAT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "charge";
const BASE_BK_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "Banque";
const BASE_BC_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "BonCommande";
const BASE_USER_URL = "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY;
const BASE_File_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "File";
// const BASE_SOCIETE_URL =
//   "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "Societe";
const BASE_SOCIETE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "Societe";
const BASE_PAYEMENT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "Payement";
const BASE_RETENU_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  FINANCE +
  "RetenuSource";

const BASE_LOGIN_URL = "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY;

const BASE_KPIFINANCE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "KPIFinance";
const BASE_CONTRACT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "Contract";
const BASE_BILL_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "Bill";
const BASE_BILL_SELL_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + FINANCE + "BillSell";
const BASE_BILL_SELL_PAYEMENT_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  FINANCE +
  "BillSellPayement";

const BASE_SPECIFICITY_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "product";
const BASE_WAREHOUSE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "warehouse";
const BASE_PURCHASEORDER_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  RETAIL +
  "purchaseOrder";
const BASE_MANUFACTURINGBATCH_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  RETAIL +
  "manufacturingBatch";
const BASE_SELLING_PRODUCT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "SellingPrice";
const BASE_FILE_URL = "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY;

const BASE_PRODUCT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "product";
const BASE_RATE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "rate";
const BASE_DOCUMENT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "document";
//Selling
const BASE_SELLING_DOCUMENT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "document";
const BASE_SELLING_PRODUCTSALES_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "productsales";
const BASE_SELLING_FILE_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  SALES +
  "uploadFileSelling";
const BASE_SELLING_ORDER_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "salesOrder";
const BASE_PACK_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + MARKETING + "/pack";
const BASE_SHOP_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "shop";
const BASE_DISCOUNT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + MARKETING + "/discount";
const BASE_RH_URL = "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RH;
const BASE_SOCIETECONTACT_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  RETAIL +
  "SocieteRestApi";

const BASE_MARKETING_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + MARKETING;
const BASE_PRODUCTION_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + PRODUCTION;

const KPI_SALE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "kpiSale";

const KPI_ACHAT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "kpiAchat";
const BASE_PRODUCT_PURCHASE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "productPurchase";

  const KPI_ALERTE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "alert";
const BASE_ABONNEMENT_URL =
  "http://" +
  SERVER_IP +
  ":" +
  SERVER_PORT +
  GATEWAY +
  MARKETING +
  "/abonnement";
const BASE_ZONE_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + SALES + "zone";
const BASE_ACCOUNT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL;

  const BASE_PAYEMENT_ACHAT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL+"payement";

const BASE_DEMANDE_ACHAT_URL =
  "http://" + SERVER_IP + ":" + SERVER_PORT + GATEWAY + RETAIL + "demandeAchat";

class UtilsUrl {


  payementAchatURL() {
    return BASE_PAYEMENT_ACHAT_URL;
  }
  LivraisonPosURL() {
    return BASE_LIVRAISON_POS_URL;
  }
  ConfigEmailPosURL() {
    return BASE_CONFIG_EMAIL_POS_URL;
  }
  HomePosURL() {
    return BASE_HOME_POS_URL;
  }
  JournalCaissePosURL() {
    return BASE_JOURNALCAISSE_POS_URL;
  }
  PayementPosURL() {
    return BASE_PAYEMENT_POS_URL;
  }
  BankPosURL() {
    return BASE_BANK_POS_URL;
  }
  WarehousePosURL() {
    return BASE_WAREHOUSE_POS_URL;
  }
  ShopPosURL() {
    return BASE_SHOP_POS_URL;
  }
  CashRegisterPosURL() {
    return BASE_CAISSE_POS_URL;
  }
  UserPosURL() {
    return BASE_USER_POS_URL;
  }
  ClientPosURL() {
    return BASE_CLIENT_POS_URL;
  }
  OrderPosURL() {
    return BASE_ORDER_POS_URL;
  }

  KpiProductionURL() {
    return BASE_KPI_PRODUCTION_URL;
  }
  fileRetailURL() {
    return BASE_FILE_URL;
  }

  SocieteContactURL() {
    return BASE_SOCIETECONTACT_URL;
  }
  // payementRHURL() {
  //   return BASE_PAYEMENT_RH_URL;
  // }
  bankURL() {
    return BASE_BK_URL;
  }
  chargeEtatURL() {
    return CHARGE_ETAT_URL;
  }
  payementSalesURL() {
    return BASE_PAYEMENT_SALES_URL;
  }
  tierAccountURL() {
    return BASE_TIERS_ACCOUNT_SALE_URL;
  }
  tierAccountRetailURL() {
    return BASE_TIERS_ACCOUNT_RETAIL_URL;
  }

  bcURL() {
    return BASE_BC_URL;
  }

  userURL() {
    return BASE_USER_URL;
  }

  fileURL() {
    return BASE_File_URL;
  }
  societeURL() {
    return BASE_SOCIETE_URL;
  }
  payementBillURL() {
    return BASE_PAYEMENT_URL;
  }
  retenuURL() {
    return BASE_RETENU_URL;
  }
  loginURL() {
    return BASE_LOGIN_URL;
  }
  kpiFinanceURL() {
    return BASE_KPIFINANCE_URL;
  }
  contract() {
    return BASE_CONTRACT_URL;
  }
  billURL() {
    return BASE_BILL_URL;
  }
  billSellURL() {
    return BASE_BILL_SELL_URL;
  }
  payementBillSellURL() {
    return BASE_BILL_SELL_PAYEMENT_URL;
  }

  //specificity
  specificityURL() {
    return BASE_SPECIFICITY_URL;
  }
  warehouseURL() {
    return BASE_WAREHOUSE_URL;
  }
  purchaseOrderURL() {
    return BASE_PURCHASEORDER_URL;
  }

  productURL() {
    return BASE_PRODUCT_URL;
  }
  rateURL() {
    return BASE_RATE_URL;
  }
  documentURL() {
    return BASE_DOCUMENT_URL;
  }
  ManufacturingBatchURL() {
    return BASE_MANUFACTURINGBATCH_URL;
  }

  //sales
  sellingProductURL() {
    return BASE_SELLING_PRODUCT_URL;
  }
  sellingDocumentURL() {
    return BASE_SELLING_DOCUMENT_URL;
  }
  sellingProductSalesURL() {
    return BASE_SELLING_PRODUCTSALES_URL;
  }
  sellingFileURL() {
    return BASE_SELLING_FILE_URL;
  }
  sellingOrderURL() {
    return BASE_SELLING_ORDER_URL;
  }
  shopURL() {
    return BASE_SHOP_URL;
  }
  packURL() {
    return BASE_PACK_URL;
  }
  discountURL() {
    return BASE_DISCOUNT_URL;
  }
  rhURL() {
    return BASE_RH_URL;
  }
  marketingURL() {
    return BASE_MARKETING_URL;
  }

  productionURL() {
    return BASE_PRODUCTION_URL;
  }

  KpiSaleURL() {
    return KPI_SALE_URL;
  }

  KpiAchatURL() {
    return KPI_ACHAT_URL;
  }

  productPurchaseURL() {
    return BASE_PRODUCT_PURCHASE_URL;
  }

  KpiAlerteURL() {
    return KPI_ALERTE_URL;
  }
  AbonnementURL() {
    return BASE_ABONNEMENT_URL;
  }
  CarteCadeauURL() {
    return BASE_CARTECADEAU_URL;
  }

  PromoCaisseURL() {
    return BASE_PROMOCAISSE_URL;
  }
  ZoneURL() {
    return BASE_ZONE_URL;
  }
  Account() {
    return BASE_ACCOUNT_URL;
  }

  demandeAchatURL() {
    return BASE_DEMANDE_ACHAT_URL;
  }
}
export default new UtilsUrl();
